export const emptyOrganization = () => ({
  id: 0,
  title: '',
  formConverted: false,
  reportLowQualityImagesEnabled: false,
  subscription: {
    currentPeriodEnd: new Date,
    features: [],
    quotas: [],
    isFree: false,
    nextSubscription: [],
    failure: undefined,
    status: 'active',
    hasPaymentMethod: false,
  },
  preferredCurrency: 'EUR',
  paysByInvoice: false,
  trialStatus: 'never-used',
  usersCount: 1,
  hasPaymentMethod: false,
  forceCurrency: false,
  onboardingFinished: false,
  onboardingViewed: false,
  firstLoginViewed: false,
  smsServiceEnabled: false,
  firstUserId: 0,
  createdAt: new Date(),
  appliedForDiscount: false,
  canSelfServeSubscription: false,
  addons: {
    approvalsEnabled: false,
    publicApiEnabled: false,
    ssoEnabled: false,
    formTranslationsEnabled: false,
    manualFormTranslationsEnabled: false,
    aiImageDescriptionEnabled: false,
    trainingsModuleEnabled: false,
  },
});
